import { apiClient } from "@/lib/api-client";
import type {
  BillingStatus,
  CheckoutSessionStatus,
  Invoice,
  RedirectResponse,
  SubscriptionProduct,
} from "@/features/billing/types";

export const billingApi = {
  status: () => apiClient.get<BillingStatus>("/v1/billing/status"),
  checkoutSession: (product: SubscriptionProduct) =>
    apiClient.post<RedirectResponse>(
      `/v1/billing/checkout-session?product=${encodeURIComponent(product)}`,
    ),
  portalSession: () => apiClient.post<RedirectResponse>("/v1/billing/portal-session"),
  checkoutSessionStatus: (sessionId: string) =>
    apiClient.get<CheckoutSessionStatus>(
      `/v1/billing/checkout-session/${encodeURIComponent(sessionId)}`,
    ),
  resync: () => apiClient.post<BillingStatus>("/v1/billing/resync"),
  invoices: () => apiClient.get<Invoice[]>("/v1/billing/invoices"),
};
